goog.provide("shadow.js.shim.module$date_fns$setDate$default");
shadow.js.shim.module$date_fns$setDate$default = shadow.js.require(201, {})["default"];
